<div class="grid-view-main-container">
  <div class="table-container">
    <table class="table">
      <thead class="thead-dark sticky-top">
        <tr>
          <th class="column-selector-container" *ngIf="showColumnSelector">
            <div (click)="openColumnOptions($event)">
              <ion-icon name="caret-down-circle-outline" class="table-header-select ion-no-padding"></ion-icon>
            </div>
          </th>
          <th class="column-selector-container px-0 ps-1" *ngIf="multiSelectProperty">
            <div class="px-0">
              <input
                type="checkbox"
                class="align-middle"
                [checked]="isAllSelected()"
                (change)="toggleSelectAllRows($event)"
              >
            </div>
          </th>
          <th class="id-column"  *ngIf="shouldShowColumn('visaId')">
            <div class="table-heading" >
               <p class="text mb-0">Visa ID</p>
               <ng-container>
                <button class="sort-btn" (click)="sortData('visaId')">
                  <ion-icon
                    [name]="sortOrder['visaId'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </button>
              </ng-container>
            </div>
          </th>
          <th class="column-width-130"  *ngIf="shouldShowColumn('firstName')">
            <div class="table-heading">
              <p class="text mb-0">Passenger Name</p>
            </div>
          </th>
          <th class="id-column"  *ngIf="shouldShowColumn('leadId')">
            <div class="table-heading" >
               <p class="text mb-0">Lead ID</p>
               <ng-container>
                <button class="sort-btn" (click)="sortData('leadId')">
                  <ion-icon
                    [name]="sortOrder['leadId'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </button>
              </ng-container>
            </div>
          </th>
          <th class=""  *ngIf="shouldShowColumn('destination')">
            <div class="table-heading">
              <p class="text mb-0">Country</p>
            </div>
          </th>
          <th class="status-column" *ngIf="shouldShowColumn('visaType')">
            <div class="table-heading" >
              <p class="text mb-0">Visa Type</p>
            </div>
          </th>
          <th class="status-column"  *ngIf="shouldShowColumn('createDate')">
            <div class="table-heading">
              <p class="text mb-0">Application Date</p>
              <ng-container>
                <button class="sort-btn" (click)="sortData('createDate')">
                  <ion-icon
                    [name]="sortOrder['createDate'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </button>
              </ng-container>
            </div>
          </th>
          <th class="status-column"  *ngIf="shouldShowColumn('status')">
            <div class="table-heading">
              <p class="text mb-0">Status</p>
            </div>
          </th>
          <th class="status-column"  *ngIf="shouldShowColumn('issueDate')">
            <div class="table-heading">
              <p class="text mb-0">Issue Date</p>
              <ng-container>
                <button class="sort-btn" (click)="sortData('issueDate')">
                  <ion-icon
                    [name]="sortOrder['issueDate'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </button>
              </ng-container>
            </div>
          </th>
          <th class="status-column"  *ngIf="shouldShowColumn('expiryDate')">
            <div class="table-heading">
              <p class="text mb-0">Expiry Date</p>
              <ng-container>
                <button class="sort-btn" (click)="sortData('expiryDate')">
                  <ion-icon
                    [name]="sortOrder['expiryDate'] === 'asc' ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
                </button>
              </ng-container>
            </div>
          </th>
          <th class="options-column">
            <div class="table-heading">
              <p class="text mb-0">Expand</p>
            </div>
          </th>
          <th class="options-column">
            <div class="table-heading border-0">
              <p class="text mb-0">Options</p>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>

        <tbody>
          <ng-container *ngFor="let row of data; index as i">
            <!-- Main Row -->
            <tr>
              <td></td>
              <td *ngIf="multiSelectProperty" class="px-0">
                <div class="px-0 ps-1">
                  <input
                    type="checkbox"
                    class="align-middle"
                    [checked]="isRowSelected(row)"
                    (change)="toggleSelectRow($event, row)"
                  >
                </div>
              </td>
              <td *ngIf="shouldShowColumn('visaId')" (click)="openVisaReviewScreen(row.visaId)"><span class="clickable-text">{{ row.visaId }}</span></td>
              <td *ngIf="shouldShowColumn('firstName')">
                <span>
                  <button class="person-name-badge">{{_globalService.createPersonNameBadge(row.firstName, row.lastName)}}</button>
                </span>
                {{ row.firstName }} {{ row.lastName }} <span *ngIf="!row.firstName && !row.lastName">--</span></td>
              <td *ngIf="shouldShowColumn('leadId')" routerLink="/leads/details/{{row.leadId}}"><span class="clickable-text">{{ row.leadId }}</span></td>
              <td *ngIf="shouldShowColumn('destination')">
                <span *ngIf="row.destination">
                  <ion-button class="location-icon"><ion-icon name="pin-outline"></ion-icon></ion-button>
                </span>
                {{ row.destination || '--' }}
              </td>
              <td *ngIf="shouldShowColumn('visaType')">{{ row.visaType || '--'}}</td>
              <td *ngIf="shouldShowColumn('createDate')">{{ row.createDate | date : 'MMM d, yyyy' }}</td>
              <td *ngIf="shouldShowColumn('status')">{{ getSelectedStatus(row.status) || '--' }}</td>
              <td *ngIf="shouldShowColumn('issueDate')">{{ (row.issueDate | date) || '--'}}</td>
              <td *ngIf="shouldShowColumn('expiryDate')">{{ (row.expiryDate | date) || '--'}}</td>
              <td>
                <span class="clickable-text" (click)="toggleRowVisibility(i)">{{ row.isExpanded ? 'Hide' : 'View' }}<ion-icon [name]="row.isExpanded ? 'caret-up-circle-outline' : 'caret-down-circle-outline'" class="ms-1 align-middle"></ion-icon></span>
              </td>
              <td>
                <div class="options text-center" (click)="showVisaGridOptions($event, row)">
                  <ion-icon name="ellipsis-horizontal-outline"></ion-icon>
                </div>
              </td>
            </tr>
        
            <!-- Expandable Detail Row -->
            <tr *ngIf="row.isExpanded">
              <td colspan="13">
                <div class="p-1 passenger-details-container">
                  <div class="bg-dark-blue p-2  rounded">
                    <div class="row passenger-row">
                      <div class="col-3">
                        <div class="passenger-input">
                          <label class="label">Passenger Name</label>
                          <div>
                            <p class="value">{{ row.firstName }} {{ row.lastName }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="passenger-input">
                          <label class="label">Age</label>
                          <div>
                            <p class="value">{{calculateAge(row.dateOfBirth)}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-1">
                        <div class="passenger-input">
                          <label class="label">Gender</label>
                          <div>
                            <p class="value">{{row.gender}}</p>
                          </div>
                        </div>
                      </div>
                      <div  class="col-1">
                        <div class="passenger-input">
                          <label class="label">Nationality</label>
                          <div>
                            <p class="value">{{row.nationality}}</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-2">
                        <div class="passenger-input">
                          <label class="label">Applicant Type</label>
                          <div>
                            <p class="value">{{row.applicantType}}</p>
                          </div>
                        </div>
                      </div>

                      <div class="col">
                        <div class="d-flex justify-content-end">
                          <ion-button [ngClass]="row.isEditable ? 'filled-blue-btn' : 'unfilled-blue-btn'" (click)="row.isEditable ? saveVisaRecord(i) : enableVisaEdit(i) ">{{row.isEditable? 'Save' : 'Edit'}}</ion-button>
                          <!-- <ion-button fill="clear" size="small" (click)="openVisaModalForm(row.leadId, row.visaId)">
                            <ion-icon name="create-outline"></ion-icon>
                          </ion-button> -->
                        </div>
                      </div>
                      
                    </div>
      
                    <div class="row my-1">
                      <div class="col-12">
                        <app-status-progress-bar-input [(ngModel)]="row.status" [isDisabled]="!row.isEditable"></app-status-progress-bar-input>
                      </div>
                    </div>
      
                    <div>
                      <table class="table">
                        <thead class="thead-dark">
                          <th class="options-column">
                            <div class="table-heading">
                              <p class="text mb-0">S No.</p>
                            </div>
                          </th>
                          <th class="column-width-130">
                            <div class="table-heading">
                              <p class="text mb-0">Document Name</p>
                            </div>
                          </th>
                          <th class="column-width-130">
                            <div class="table-heading">
                              <p class="text mb-0">Document No.</p>
                            </div>
                          </th>
                          <th class="status-column">
                            <div class="table-heading">
                              <p class="text mb-0">Valid From</p>
                            </div>
                          </th>
                          <th class="status-column">
                            <div class="table-heading">
                              <p class="text mb-0">Valid To</p>
                            </div>
                          </th>
                          <th>
                            <div class="table-heading">
                              <p class="text mb-0">Upload</p>
                            </div>
                          </th>
                        </thead>
                      
                        <tbody>
                          <tr *ngFor="let document of row.documents; let docIndex = index">
                            <td>{{docIndex + 1}}</td>
                            <td>{{document.documentName}}</td>
                            <td>
                              <div class="table-input" [ngClass]="!row.isEditable ? 'viewOnly':''">
                                <input type="text" class="input" [(ngModel)]="document.documentNumber" [disabled]="!row.isEditable">
                              </div>
                            </td>
                            <td>
                              <div class="table-input" [ngClass]="!row.isEditable ? 'viewOnly':''">
                                <app-date-picker [selectedDate]="convertToDate(document.validFrom)" (change)="visaDocumentValidFromChanged($event, i, docIndex)" [isDisabled]="!row.isEditable"></app-date-picker>
                              </div>
                            </td>
                            <td>
                              <div class="table-input" [ngClass]="!row.isEditable ? 'viewOnly':''">
                                <app-date-picker [selectedDate]="convertToDate(document.validTo)" (change)="visaDocumentValidToChanged($event, i, docIndex)" [isDisabled]="!row.isEditable"></app-date-picker>
                              </div>
                            </td>
                            <td>
                              <div class="table-input d-flex">
                                <label *ngIf="row.isEditable" [attr.for]="'visa'+i+'doc'+docIndex" class="upload-btn"><ion-icon name="cloud-upload-outline"></ion-icon></label>
                                <div class="file-view" *ngIf="document.document"><p class="clickable-text mb-0" (click)="openAttachment(document.document)">View Document</p></div>
                                <input [attr.id]="'visa'+i+'doc'+docIndex" type="file" class="d-none" (change)="onDocumentSelected($event, i, docIndex)" accept="image/*,.pdf">
                              </div>
                            </td>
      
                          </tr>
      
                          <tr *ngIf="!row.documents || row.documents?.length === 0">
                            <td colspan="7" class="text-center">
                              <p class="my-2">No Documents Selected!</p>
                            </td>
                          </tr>
                          
                        </tbody>
                        
                      </table>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          
          <tr *ngIf="allData && data.length === 0">
            <td colspan="10" class="text-center py-3">No Results Found!</td>
          </tr>
        </tbody>
        
    </table>
  </div>

  <div class="w-100 paginations-container" *ngIf="!hidePaginations">
    <div class="d-flex justify-content-between w-100">
      <div class="d-flex align-items-center">
        <div class="select-container">
          <select name="" id="" class="records-selector" [(ngModel)]="paginationSettings.pageSize" (change)="onPageSizeChange()">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
        <div class="label-container">
          <p class="label">Showing {{noOfRows}} records of {{paginationSettings.totalCount}}</p>
        </div>
      </div>
  
      <div class="control-btns">
        <div class="buttons-row">
          <!-- Back btn -->
          <ion-button class="control-btn" (click)="onPrevious()" [disabled]="paginationSettings.pageNumber === 1">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
  
          <!-- pages buttons list -->
          <ion-button 
            class="control-btn" 
            *ngFor="let page of visiblePages" 
            (click)="onPageChange(page)" 
            [class.active]="page === paginationSettings.pageNumber">
            {{page}}
          </ion-button>
  
          <!-- Forward btn -->
          <ion-button class="control-btn" (click)="onNext()" [disabled]="paginationSettings.pageNumber === paginationSettings.totalPages">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </ion-button>
        </div>
      </div>
    </div>
  </div>

</div>
